import { Box, LinearProgress, styled, Typography } from '@mui/material';

export const ProgressBarContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '16px',
}));

export const OverBarContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.mainFocused,
}));

export const StepsCounter = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onPrimaryBackground,
}));

export const ProgressBarStyled = styled(LinearProgress)(({ theme }) => ({
  height: '5px',
  backgroundColor: theme.palette.colors.disabledOnPrimaryBackground,
  borderRadius: '3px',

  '& .MuiLinearProgress-bar': {
    backgroundColor: theme.palette.colors.highlight,
    borderRadius: '3px',
  },
}));
